<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <b style="line-height:1.5;">
          <span style="font-size:18px;">铝卷，铝板，铝箔，罐身料</span>
        </b>
      </p>
      <p>
        <span style="font-size:12px;">
          <span style="font-size:12px;">&nbsp;</span>
        </span>
        <span style="font-size:12px;">合金：</span>
        <span style="font-size:12px;">1XXX, 3XXX, 5XXX</span>
      </p>
      <p>
        <span style="font-size:12px;">
          <span style="font-size:12px;">&nbsp;</span>
        </span>
        <span style="font-size:12px;">标准：</span>
        <span style="font-size:12px;">ASTM B209, DIN EN 485, JIS H4000</span>
        <span style="font-size:12pt;"></span>
      </p>
      <p>
        <span style="font-size:12px;">
          <span style="font-size:12px;">&nbsp;</span>
        </span>
        <span style="font-size:12px;">标准尺寸：铝卷</span>
        <span style="font-size:12px;">0.1mm</span>
        <span style="font-size:12px;">-5.0mm</span>
        <span style="font-size:12px;">;</span>
        <span style="font-size:12px;">铝板</span>
        <span style="font-size:12px;">0.3mm-5.0mm;</span>
        <span style="font-size:12px;">铝箔</span>
        <span style="font-size:12px;">0.006mm</span>
        <span style="font-size:12px;">-0.2mm</span>
        <span style="font-size:12pt;"></span>
      </p>
      <p>
        <span style="font-size:12px;">
          <span style="font-size:12px;">&nbsp;</span>
        </span>
        <span style="font-size:12px;">宽度：铝卷</span>
        <span style="font-size:12px;color:#333333;">300</span>
        <span style="font-size:12px;">mm</span>
        <span style="font-size:12px;">-2150mm</span>
        <span style="font-size:12px;">;</span>
        <span style="font-size:12px;">铝板</span>
        <span style="font-size:12px;">600mm-2150mm;</span>
        <span style="font-size:12px;">铝箔</span>
        <span style="font-size:12px;">250mm</span>
        <span style="font-size:12px;">-1500mm</span>
      </p>
      <p>
        <span style="font-size:12px;">
          <br>
        </span>
      </p>
      <p>
        <img :src="images.lb1" width="210" height="158" alt>&nbsp;&nbsp;
        <img :src="images.lb2" width="210" height="158" alt style="line-height:1.5;">&nbsp;&nbsp;
        <img :src="images.lb3" width="210" height="157" alt style="line-height:1.5;">
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        lb1: require("../../../assets/img/common/lb1.jpg"),
        lb2: require("../../../assets/img/common/lb2.jpg"),
        lb3: require("../../../assets/img/common/lb3.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/product/lb.vue